import { createRequest, composeRequestConfig } from 'core/utils/axios/api';
import { teamsEnv } from 'core/utils';

export const submitWork = (params, payload) => {
  const url = `/api/v1/ms_teams/${teamsEnv.tenantId}/channels/${teamsEnv.channelId}/assignments/${params.assignmentId}/submissions/${params.id}`;

  const config = composeRequestConfig({ url, method: 'patch', payload });
  return createRequest(config);
};
